const ABSOLUTE_URL_PATTERN = /^(?:[a-z][a-z0-9+.-]*:|\/\/|#)/i;
const CSS_URL_PATTERN = /url\(\s*(['"]?)(.*?)\1\s*\)/gi;

function getCurrentOrigin(): string | null {
  if (typeof window === 'undefined' || !window.location?.origin) {
    return null;
  }

  return window.location.origin;
}

function normalizeSiteBaseUrl(siteBaseUrl: string): string | null {
  if (!siteBaseUrl) {
    return null;
  }

  try {
    const normalized = new URL(siteBaseUrl).toString();
    return normalized.endsWith('/') ? normalized : `${normalized}/`;
  } catch {
    return null;
  }
}

function shouldRewriteRelativeAsset(siteBaseUrl: string, currentOrigin = getCurrentOrigin()): boolean {
  const normalizedSiteBaseUrl = normalizeSiteBaseUrl(siteBaseUrl);

  if (!normalizedSiteBaseUrl || !currentOrigin) {
    return false;
  }

  try {
    return new URL(normalizedSiteBaseUrl).origin !== currentOrigin;
  } catch {
    return false;
  }
}

function isRelativeAssetUrl(assetUrl: string): boolean {
  const normalizedAssetUrl = assetUrl?.trim();

  if (!normalizedAssetUrl) {
    return false;
  }

  return !ABSOLUTE_URL_PATTERN.test(normalizedAssetUrl);
}

export function resolveSiteAssetUrl(
  assetUrl: string,
  siteBaseUrl: string,
  currentOrigin = getCurrentOrigin(),
): string {
  const normalizedAssetUrl = assetUrl?.trim();

  if (!isRelativeAssetUrl(normalizedAssetUrl)) {
    return assetUrl;
  }

  const normalizedSiteBaseUrl = normalizeSiteBaseUrl(siteBaseUrl);
  if (!normalizedSiteBaseUrl || !shouldRewriteRelativeAsset(normalizedSiteBaseUrl, currentOrigin)) {
    return assetUrl;
  }

  try {
    return new URL(normalizedAssetUrl, normalizedSiteBaseUrl).toString();
  } catch {
    return assetUrl;
  }
}

export function resolveSiteAssetCssValue(
  cssValue: string,
  siteBaseUrl: string,
  currentOrigin = getCurrentOrigin(),
): string {
  if (!cssValue?.includes('url(') || !shouldRewriteRelativeAsset(siteBaseUrl, currentOrigin)) {
    return cssValue;
  }

  return cssValue.replace(CSS_URL_PATTERN, (fullMatch, quote: string, assetUrl: string) => {
    const resolvedAssetUrl = resolveSiteAssetUrl(assetUrl, siteBaseUrl, currentOrigin);

    if (resolvedAssetUrl === assetUrl) {
      return fullMatch;
    }

    return `url(${quote}${resolvedAssetUrl}${quote})`;
  });
}